export default __webpack_public_path__ + "static/media/no_chat.a9a2b95f.svg";